export const formatNameHelper = (name: string) =>
  name
    .toLowerCase()
    .split(' ')
    .map((n: string) => n[0].toUpperCase() + n.slice(1))
    .join(' ');
